const headerOptions = [
  { title: "User Name(User ID)" },
  { title: "Group Name" },
  { title: "Designation" },
  { title: "Email" },
  { title: "Phone Number" },
  { title: "Comment" }
];

const params = {
  limit: 10,
  offset: 0
};

export { headerOptions, params };
